import http from "../../utils/http"

/**
 * 获取新闻列表
 */
export function buyList(params) {
    return http({
        url: "/api/buy/page",
        data: params
    })
}


/**
 * 获取帮助详情
 */
export function buyDetail(params) {
    return http({
        url: "/api/buy/detail",
        data: params
    })
}
